import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Homepage from "./pages/Homepage";
import Solutions from "./pages/Solutions";
import Process from "./pages/Process";
import CaseStudies from "./pages/CaseStudies";
import Resources from "./pages/Resources";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import Unsubscribe from "./pages/Unsubscribe";
import ArticleConceptDrift from "./pages/articles/ArticleConceptDrift";
import ArticleTrainingData from "./pages/articles/ArticleTrainingData";
import ArticleRLHF from "./pages/articles/ArticleRLHF";
import ArticleScalingHITL from "./pages/articles/ArticleScalingHITL";
import ArticleEdgeCases from "./pages/articles/ArticleEdgeCases";
import ArticleLiDAR from "./pages/articles/ArticleLiDAR";
import ArticleQualityMetrics from "./pages/articles/ArticleQualityMetrics";
import ArticleAnnotationWorkflows from "./pages/articles/ArticleAnnotationWorkflows";
import ArticleMultimodalAI from "./pages/articles/ArticleMultimodalAI";
import ArticleVanityMetric from "./pages/articles/ArticleVanityMetric";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import CaseStudySliceVault from "./pages/CaseStudySliceVault";
import CaseStudySpiideo from "./pages/CaseStudySpiideo";
import CaseStudyKatam from "./pages/CaseStudyKatam";

// The admin table is an internal tool, not part of the public site, so it is
// rendered without the marketing header and footer.
function SiteChrome({ children }) {
  const bare = useLocation().pathname.startsWith("/admin");
  return (
    <>
      {!bare && <Header />}
      {children}
      {!bare && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <SiteChrome>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/process" element={<Process />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/case-study-slicevault" element={<CaseStudySliceVault />} />
          <Route path="/case-study-spiideo" element={<CaseStudySpiideo />} />
          <Route path="/case-study-katam" element={<CaseStudyKatam />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/resources/vanity-metric" element={<ArticleVanityMetric />} />
          <Route path="/resources/concept-drift" element={<ArticleConceptDrift />} />
          <Route path="/resources/training-data-quality" element={<ArticleTrainingData />} />
          <Route path="/resources/rlhf-best-practices" element={<ArticleRLHF />} />
          <Route path="/resources/scaling-hitl-ai" element={<ArticleScalingHITL />} />
          <Route path="/resources/edge-case-management" element={<ArticleEdgeCases />} />
          <Route path="/resources/lidar-annotation" element={<ArticleLiDAR />} />
          <Route path="/resources/quality-metrics" element={<ArticleQualityMetrics />} />
          <Route path="/resources/annotation-workflows" element={<ArticleAnnotationWorkflows />} />
          <Route path="/resources/multimodal-ai-data" element={<ArticleMultimodalAI />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          
          {/* Catch-all route: Redirect any undefined/old URLs to homepage */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </SiteChrome>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
